import React from 'react';
import styles from '../branches/BranchingOpsSection.module.css';
import Ico from '../common/Ico';
import Btn from '../common/Btn';
import Pill from '../common/Pill';
import { validateBinaries } from '../../api/releases';
import { setAlert } from '../../helpers/alerts';

const ICO_CHECK = 'M20 6 9 17l-5-5';

function isDotZero(version) {
  const parts = String(version || '').split('-', 1)[0].split('.');
  return parts.length >= 3 && parts[2] === '0';
}

export default function ValidateBinariesSection({ release, onValidated }) {
  const [busy, setBusy] = React.useState(false);

  const validated = Boolean(release.binaries_validated_at);
  const canValidate = release.status === 'released' && !validated;
  if (!canValidate && !validated) return null;

  const dotZero = isDotZero(release.version);
  const subtitle = validated
    ? `Validated by ${release.binaries_validated_by || 'unknown'} on ${new Date(release.binaries_validated_at).toLocaleString()}`
    : dotZero
      ? 'Confirm the binaries and release notes are good. Charts/terraform stay manual for .0 releases.'
      : 'Confirm the binaries and release notes are good. This triggers the helm chart / terraform releases automatically.';

  const onClick = () => {
    setBusy(true);
    validateBinaries(release.version)
      .then(() => {
        setAlert('Binaries validated', dotZero ? 'Marked as validated' : 'Helm chart / terraform releases triggered', 'success');
        onValidated?.();
      })
      .catch((err) => {
        setAlert('Validate binaries error', err, 'danger');
      })
      .finally(() => setBusy(false));
  };

  return (
    <section className={styles.section} id="sec-validate-binaries">
      <div className={styles.header}>
        <span className={styles.iconTile}>
          <Ico d={ICO_CHECK} size={16} strokeWidth={1.7} />
        </span>
        <div className={styles.headerText}>
          <div className={styles.title}>Validate binaries</div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>
        {validated ? (
          <Pill kind="ok" dot>Validated</Pill>
        ) : (
          <Btn variant="primary" size="md" icon={ICO_CHECK} onClick={onClick} disabled={busy}>
            {busy ? 'Validating…' : 'Binaries validated'}
          </Btn>
        )}
      </div>
    </section>
  );
}
